import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { Skeleton } from "@/components/ui/skeleton";

function StatCardSkeleton() {
  return (
    <Card className="min-h-[170px] rounded-2xl border-dash-border shadow-none">
      <CardHeader className="px-6 pb-0 pt-6">
        <Skeleton className="h-3 w-28" />
      </CardHeader>
      <CardContent className="flex flex-col gap-3 px-6 pb-6 pt-5">
        <Skeleton className="h-12 w-24" />
        <Skeleton className="h-4 w-32" />
      </CardContent>
    </Card>
  );
}

function HighlightCardSkeleton({ compact = false }: { compact?: boolean }) {
  return (
    <Card className="flex h-[420px] flex-col overflow-hidden rounded-2xl border-dash-border shadow-none">
      <CardHeader className="flex-row items-center justify-between px-6 py-5">
        <div className="flex items-center gap-3">
          {!compact && <Skeleton className="size-2.5 rounded-full" />}
          <Skeleton className="h-6 w-36" />
          {!compact && <Skeleton className="size-6 rounded-full" />}
        </div>
        <Skeleton className="h-8 w-20" />
      </CardHeader>
      <Separator className="bg-dash-border" />
      <CardContent className="p-0">
        {[0, 1, 2, 3].map((row) => (
          <div key={row}>
            {row > 0 && <Separator className="bg-dash-borderSoft" />}
            <div className="flex items-center gap-4 px-6 py-5">
              <Skeleton className={compact ? "size-9 shrink-0 rounded-full" : "size-2 shrink-0 rounded-full"} />
              <div className="flex min-w-0 flex-1 flex-col gap-2">
                <Skeleton className="h-4 w-3/5" />
                <Skeleton className="h-3 w-4/5" />
              </div>
              {!compact && <Skeleton className="size-8 shrink-0 rounded-full" />}
              <Skeleton className="hidden h-4 w-16 sm:block" />
            </div>
          </div>
        ))}
      </CardContent>
    </Card>
  );
}

export default function OverviewSkeleton() {
  return (
    <div className="flex flex-col gap-5" aria-label="Loading overview" role="status">
      <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
        {[0, 1, 2, 3].map((item) => <StatCardSkeleton key={item} />)}
      </div>
      <div className="grid gap-5 xl:grid-cols-[1.35fr_1fr]">
        <HighlightCardSkeleton />
        <HighlightCardSkeleton compact />
      </div>
      <span className="sr-only">Loading overview cards…</span>
    </div>
  );
}
